import { InvoiceStatus } from '@prisma/client';

import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { ALLOCATE_PAYMENT } from 'src/graphql/mutations/allocatePayment.mutation';

function useAllocateInvoicePayment(invoiceId: string, invoiceType: string) {
    const [allocatePayment, { loading: allocating }] = useMutation(ALLOCATE_PAYMENT, {
        onError(error) {
            showErrorToast(error.message ?? 'An error occurred allocating payment');
        },
        onCompleted: ({ message }) => {
            showSuccessToast(message ?? 'Payment allocated');
        },
    });

    const status = (balance: number, paymentAmount: number, totalInvoiceAmount: number) => {
        const outstandingBalance = balance - paymentAmount;
        if (outstandingBalance === 0) {
            return InvoiceStatus.PAID;
        } else if (outstandingBalance > 0 && outstandingBalance < totalInvoiceAmount) {
            return InvoiceStatus.PARTIALLY_PAID;
        }
        return InvoiceStatus.UNPAID;
    };

    return {
        isAllocatingPayment: allocating,
        allocateInvoicePayment: async (
            paymentAmountInCents: number,
            paymentMethod: string,
            balanceInCents: number,
            date: Date,
            totalInvoiceAmount: number
        ) => {
            await allocatePayment({
                variables: {
                    input: {
                        paymentAmount: paymentAmountInCents,
                        paymentMethod,
                        status: status(balanceInCents, paymentAmountInCents, totalInvoiceAmount),
                        id: invoiceId,
                        balance: balanceInCents,
                        date,
                        invoiceType,
                    },
                },
            });
        },
    };
}
export default useAllocateInvoicePayment;
